import {
  ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Inject, Input, Output, PLATFORM_ID,
  ViewEncapsulation
} from '@angular/core';

import { PositionEnum, PushSizeEnum, SdThemeComponent, ThemesEnum } from '@seb/web-design-system/core';

import type { IVisualCardWithConfig } from './visual-card/visual-card.interface';
import { SdVisualCardComponent } from './visual-card/visual-card.component';

@Component({
  selector: 'sd-visual-cards',
  templateUrl: './visual-cards.component.html',
  styleUrls: ['./visual-cards.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdVisualCardComponent]
})
export class SdVisualCardsComponent extends SdThemeComponent {
  constructor(@Inject(PLATFORM_ID) protected platformId: any) {
    super();
  }

  themesEnum = ThemesEnum;

  @Input()
  hasMargin = false;

  @Input()
  isLoading = false;

  @Input()
  cards: IVisualCardWithConfig[];

  /**
   * Allow to define de size of the visual card wanted
   * Changes content size
   */
  @Input()
  visualCardsSize: PushSizeEnum = PushSizeEnum.m;

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel = 3;

  /**
   * Determines whether the title is inside a hx tag or in a p tag for the title
   */
  @Input()
  isDescription = false;

  @Input()
  invertTitle = false;

  /**
   * Allow to define if the text is aligned to the top or the bottom, or even centered
   * * @param {string} left | right | center
   */
  @Input()
  layoutTextConfig:
    | PositionEnum.top
    | PositionEnum.bottom
    | PositionEnum.center = PositionEnum.center;

  @Input()
  twicPicsAutoSize = true;

  @Output()
  videoPlayed = new EventEmitter<{ status: string; title: string }>();

  @Output()
  videoEnded = new EventEmitter<{ status: string; title: string }>();

  @Input()
  class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.layoutTextConfig ? 'is-layout-' + this.layoutTextConfig : '',
      this.visualCardsSize ? 'is-size-' + this.visualCardsSize : '',
      this.hasMargin ? 'has-margin' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  onVideoPlayed(event) {
    this.videoPlayed.emit(event);
  }

  onVideoEnded(event) {
    this.videoEnded.emit(event);
  }
}
